import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import SoftTokensActivateTokenRegisterCodePage, { getDefaultData } from "components/pages/SoftTokensActivateTokenRegisterCodePage";
/**
 * @name CaptureSoftTokenActivationActivateTokenCodeEntered
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Activation".
 */
export default function CaptureSoftTokenActivationActivateTokenCodeEntered(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "registrationCode" ], { value: "913 365 002 813 383 1" })
    .submit();

    return <SoftTokensActivateTokenRegisterCodePage data={ data } />;
}